import { reportUrl, ediFiscalUrl } from "../Config/Url";
import axios from "axios";

export const invoiceService = {
  fiscal,
  ediFiscal
};

async function fiscal(id) {
  return axios
    .post(`${reportUrl}fiscal-invoice/${id}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function ediFiscal(id) {
  var fiscalToken = "lFzLM6rsZhOAmWplY5xU";
  return axios
    .post(`${ediFiscalUrl}/${id}`, null, {
      headers: {
        "X-FiscalToken": fiscalToken,
      },
    })
    .then((res) => res)
    .catch((err) => err.response);
}

